import { SVGProps } from "react"
const LeftArrow2Icon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.5625 41.5L32.1458 27.9167C33.75 26.3125 33.75 23.6875 32.1458 22.0833L18.5625 8.5"
      stroke={props.color || "white"}
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default LeftArrow2Icon
